module.exports = __webpack_public_path__ + "assets/thumb-house@2x.0a9c0d13.png";